export default __webpack_public_path__ + "static/media/ab03.46a7a322.jpg";